import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Settings } from '../store/reducers/AccountSlice';
import { isModuleEnabled, TenantModule } from '../shared/tenantModules';

type Props = {
  module: TenantModule;
  children: JSX.Element;
};

export const ModuleRoute = ({ module, children }: Props) => {
  const settings: Settings = useSelector((state: any) => state.settings.value);

  if (!isModuleEnabled(settings.enabledModules, module)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
